import React, { useState } from "react";
import { TextField, SortMenu } from "@ann/web-components";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./Filters.styled";

const Filters = ({
  onSortChange,
  onOrderChange,
  selectedSortOption = "createdAt",
  orderDirection = "desc",
  onSearchChange,
  loading = false,
}) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (value) => {
    setSearchValue(value);
    onSearchChange?.(value);
  };

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <TextField
          iconLeft="search"
          onChange={handleSearchChange}
          size="small"
          placeholder="Search"
          value={searchValue}
          disabled={loading}
        />
      </FiltersLeftContent>

      <FiltersRightContent>
        <SortMenu
          minWidth="200px"
          onChange={(id) => {
            if (onSortChange) {
              onSortChange(id);
            }
          }}
          order={orderDirection ? orderDirection.toLowerCase() : "desc"}
          onOrderChange={(newOrder) => {
            if (onOrderChange) {
              onOrderChange(newOrder);
            }
          }}
          options={[
            {
              icon: 'clock',
              id: 'createdAt',
              label: 'Most Recent'
            },
            {
              icon: 'sortByAlpha',
              id: 'fullName',
              label: 'Name (A-Z)'
            },
            {
              icon: 'email',
              id: 'email',
              label: 'Email'
            },
            {
              icon: 'update',
              id: 'updatedAt',
              label: 'Last Updated'
            }
          ]}
          selected={selectedSortOption || "createdAt"}
          size="medium"
          title="SORT BY"
          width="240px"
          disabled={loading}
        />
      </FiltersRightContent>
    </FiltersContainer>
  );
};

export default Filters;
